import { useMemo, useContext } from "react";
import PropTypes from "prop-types";
import Chip from "@mui/material/Chip";
import Skeleton from "@mui/material/Skeleton";
import { SeverityTypeContext } from "contexts/SeverityTypeContext";
import { styled } from "@mui/material/styles";
import { withTransientProps } from "core/utils/transientProps";

export default function SeverityChip({ id, severity, fullWidth }) {
  const { loading, error, severityTypes } = useContext(SeverityTypeContext);

  const severityType = useMemo(
    () => severityTypes.find(({ id }) => id === severity),
    [severity, severityTypes]
  );

  if (loading) {
    return <Skeleton />;
  }

  if (error) {
    return <>Severity not found</>;
  }

  return (
    <ColouredChip
      id={id}
      label={severityType?.name ?? "None"}
      $fullWidth={fullWidth}
      $severityColor={severityType?.color}
      $backgroundColor={severityType?.backgroundColor}
      data-qa="Multi-Severity-Chip"
    />
  );
}

SeverityChip.propTypes = {
  id: PropTypes.string,
  severity: PropTypes.number,
  fullWidth: PropTypes.bool
};

const ColouredChip = styled(Chip, withTransientProps)`
  height: 30px;
  font-size: 13px;
  width: ${({ $fullWidth }) => $fullWidth && "100%"};
  color: ${({ $severityColor }) => $severityColor};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
`;
